import { Overlay } from 'ol';
import { type Coords } from '#shared/lib/coords';
import type { Map } from './map';
import { fromCoords } from './utils';

export type MapPopupRendererOptions = {
  element: HTMLElement;
};

export class MapPopupRenderer {
  #overlay: Overlay;

  constructor({ olMap }: Map, options: MapPopupRendererOptions) {
    const overlay = new Overlay({
      element: options.element,
    });
    this.#overlay = overlay;
    olMap.addOverlay(overlay);
  }

  setPosition(coords: Coords) {
    this.#overlay.setPosition(fromCoords(coords));
  }
}
